import "./DepartmentsTabUI.css"

import { CircularProgress, useTheme } from "@mui/material";
import { FC, useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { DepartmentTabToolbar } from "./DepartmentTabToolbar/DepartmentTabToolbar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { RHookFormDatePicker } from "../../../../RHookFormDatePicker";
import { departmentsInitialData, } from "../../../EmployeeAssignemnt";
import { formatDate } from "../../../../../common/Common";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";

// import { Button } from "primereact/button";

// import { Toolbar } from "primereact/toolbar";










let emptyDepartment = {
  id: null,
  departments: "",
  fromDate: null,
  toDate: null,
  notes: "",
  rowWithRandomId: true
};



interface IDepartmentsTabsPanel {
  departmentsUpdatedData: (data: any) => void;
  departmentsDataItems: any;
  departmentsDDLData: any
  TabTableheaderColumns: any
  selectedEmployeeLabel: string;
  onRowDeleteClicked: (data: any) => void;
}
export const DepartmentsTabsPanel: FC<IDepartmentsTabsPanel> = ({
  departmentsUpdatedData,
  departmentsDataItems,
  departmentsDDLData,
  TabTableheaderColumns,
  selectedEmployeeLabel,
  onRowDeleteClicked
}) => {
  const theme = useTheme()
  const [departments, setDepartments] = useState<any>(departmentsDataItems);
  const [selectedDepartments, setSelectedDepartments] = useState<any>(null);
  const [department, setDepartment] = useState(emptyDepartment);
  const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
  // const [employeeStatusFieldsEmpty, setEmployeeStatusFieldsEmpty] = useState(emptyEmpStatus);


  useEffect(() => {
    departmentsUpdatedData(departments);
  }, [departments]);

  useEffect(() => {

    setDepartments(departmentsDataItems);
  }, [departmentsDataItems]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < departments.length; i++) {
      if (departments[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = '';
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  // const openNew = () => {
  //   // alert("new")

  //   let _departments = [...departments];
  //   let _department: any = { ...department };

  //   if (department.id) {
  //     const index = findIndexById(department.id);

  //     _departments[index] = _department;
  //   } else {
  //     _department.id = createId();
  //     _departments.push(_department);
  //   }



  //   setDepartments(_departments);
  //   setDepartment(emptyDepartment);
  // };

  const openNew = () => {
    // if (employeeStatus && employeeStatus.length >= 4) return null;
    let _departmentsSetupPanelData = [...departments];
    let _departmentSetupPanelNewRow: any = { ...department };

    if (department.id) {
      const rowIndex = findIndexById(department.id);
      _departmentsSetupPanelData[rowIndex] = _departmentSetupPanelNewRow;

    } else {
      const newRowId = createId();
      _departmentSetupPanelNewRow.id = newRowId;
      _departmentsSetupPanelData.push(_departmentSetupPanelNewRow);
      setLastAddedRowId(newRowId && newRowId);

    }
    setDepartments(_departmentsSetupPanelData);
    setDepartment(emptyDepartment);
  };


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    // const updatedData = [...departments];
    // updatedData[rowIndex][event.field] = field;
    // setDepartments(updatedData);

    setDepartments((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
      return updatedData;
    });
  };

  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
    if (field.field === "fromDate") {
      if (rowData.departments !== "" && rowData.departments !== undefined && rowData.departments !== null) {
        if (rowData.fromDate === null) {
          return "p-component p-filled calender-error-input";
        } else if (rowData.fromDate === "") {
          return "p-component p-filled calender-error-input";
        }
      }
    } else if (field.field === "departments") {
      if (
        rowData.fromDate !== "" &&
        rowData.fromDate !== undefined &&
        rowData.fromDate !== null
      ) {
        if (rowData.departments === null) {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        } else if (rowData.departments === "") {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        }
      } else {
        return "p-component p-filled input-dropdown-fields .p-dropdown";
      }
    } else {
      return "p-component p-filled input-dropdown-fields";
    }
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === 'label') {
      return (
        <span><b>Select Department </b></span>
        // <span style={{ color: "red" }}>*</span>
      )
    } else if (x.field === 'departments') {
      return (
        <Dropdown
          options={departmentsDDLData}
          value={rowData[x.field]}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value)}
          placeholder="--"
          className={renderErrorClass(x, row.rowIndex, rowData)}
          optionLabel="label"
          optionValue="value"
        />
      )
    } else if (x.field === 'fromDate') {
      return (
        <Calendar
          id="fromDate"
          value={rowData[x.field]}
          showIcon
          // className="calender"
          style={{ height: '2.6rem', margin: "8px 0px 4px 0px", width: "auto" }}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          dateFormat="M dd, yy"
          placeholder={"dd/mm/yyyy"}
          showButtonBar
          className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
        />
      )
    } else if (x.field === 'toDate') {
      return (
        <Calendar
          id="fromDate"
          value={rowData[x.field]}
          showIcon
          className="calender"
          style={{ height: '2.6rem', margin: "8px 0px 4px 0px", width: "auto" }}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          dateFormat="M dd, yy"
          placeholder={"dd/mm/yyyy"}
          showButtonBar
        />
      )
    } else if (x.field === 'notes') {
      return (
        <InputText
          value={rowData[x.field]}
          onChange={(e: any) =>
            onCellValueChange(x, row.rowIndex, e.target.value)
          }
          placeholder="Write notes here"
          className={'notesField p-component p-filled input-dropdown-fields'}
        />
      )
    }
  }


  const onDeleteNewAddedRow = (rowId: any) => {
    setDepartments((prev: any[]) => {
      const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

      if (rowDeleteBasedOnId.length > 1) {
        const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
        setLastAddedRowId(lastRowId);
      } else {
        setLastAddedRowId(null);
      }
      return rowDeleteBasedOnId;
    });
  }

  return (
    <>
      {departmentsDDLData ? <div className="card">
        <DepartmentTabToolbar
          openNew={openNew}
          selectedEmployeeLabel={selectedEmployeeLabel}
        />
        <DataTable
          value={departments}
          // key={JSON.stringify(departmentsDDLData)}
          // selection={selectedDepartments} 
          // onSelectionChange={(e) => setSelectedDepartments(e.value)}
          dataKey="id"
          key={lastAddedRowId}
          showGridlines
          className="DepartmentsTab"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          // selectionMode="checkbox"
          scrollHeight="516px"
        >
          {TabTableheaderColumns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                headerTooltip={x.description}
                headerTooltipOptions={{ position: "top" }}
                sortable={false}
                // resizeable={x.resizable}
                // dataType={x.type}
                align={x.align}
                alignHeader={x.headerAlign}
                reorderable={false}
                // exportable={x.disableExport}
                frozen={x.frozenColumn}
                columnKey={x.field}
                style={{
                  width: x.minWidth,
                  fontSize: "0.875rem",
                }}
                footer={x.footer}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}

          {/* <Column
            body={(rowData: any, row: any) => {
              const showIcon = rowData.id === lastAddedRowId;
              return showIcon ? (
                <EnhancedButtonPrimeReact
                  icon="pi pi-times"
                  severity={EnhancedButtonPrimeReactSeverity.Danger}
                  className="p-button-rounded p-button-text shadow-none bg-transparent"
                  rounded
                  // onClickHandler={onDeleteNewAddedRow}
                  onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
                />
              ) : null;
            }}
          /> */}
          <Column
            body={(rowData: any, row: any) => {
              const isLastRow = row.rowIndex === departments.length - 1;
              console.log("isLastRow", isLastRow)
              return isLastRow ? (
                <EnhancedButtonPrimeReact
                  icon="pi pi-times"
                  severity={EnhancedButtonPrimeReactSeverity.Danger}
                  className="p-button-rounded p-button-text shadow-none bg-transparent  delete-row-btn"
                  rounded
                  onClickHandler={() => rowData.rowWithRandomId ? onDeleteNewAddedRow(rowData.id) : onRowDeleteClicked(rowData)}
                />
              ) : null;
            }}
          />

        </DataTable>
      </div> : <></>}
    </>
  );
};
